export const USER_COMMUNITY_PREFERENCES_MUTATION = `
mutation UserCommunityPreferences($communityIds: [ID!]!) {
        me {
            userCommunityPreferences(communityIds: $communityIds)
        }
    }
`;
